import type { ExtentCommon } from '@tsyl/karonte/lib/types/view'

export const worldExtent = {
  xmax: 11218838.066656137,
  xmin: -17271994.108239748,
  ymax: 10832754.847138185,
  ymin: -5271609.768204749
} as ExtentCommon
